import { createSelector } from 'reselect';
const getTeamInfo = (state) => state?.config?.teamInfo;

export const getTeamInfoState = createSelector(
    [getTeamInfo], (teamInfo) => {
        return teamInfo;
    }
);
